module.exports = __webpack_public_path__ + "static/media/ams2.b50e3bab.jpg";